export const ratingValue = 4
export const iconUrl = 'images/coches/logos/logo-coches-small.svg'
export const storeUrl = {
  android: 'https://coches.onelink.me/1823422424/3e4a74d9',
  ios: 'https://itunes.apple.com/es/app/coches-net-coches-de-segunda-mano/id333895109?l=ca&mt=8'
}

export const IS_SMARTBANNER_APPSFLYER_ENABLED = true

export const SMARTBANNER_COOLDOWN_HOURS = {
  DEFAULT: 24,
  AFTER_INSTALL_CLICK: 48
}

const SMARTBANNER_SOURCE_ID_DEFAULT = 'default'
const SMARTBANNER_SOURCE_ID_HOME = 'home'
const SMARTBANNER_SOURCE_ID_ADS_LIST = 'ads_list'
const SMARTBANNER_SOURCE_ID_ADS_DETAIL = 'ads_detail'
const SMARTBANNER_SOURCE_ID_EDITORIAL = 'editorial'

export const SMARTBANNER_SOURCE_IDS = {
  DEFAULT: SMARTBANNER_SOURCE_ID_DEFAULT,
  HOME: SMARTBANNER_SOURCE_ID_HOME,
  ADS_LIST: SMARTBANNER_SOURCE_ID_ADS_LIST,
  ADS_DETAIL: SMARTBANNER_SOURCE_ID_ADS_DETAIL,
  EDITORIAL: SMARTBANNER_SOURCE_ID_EDITORIAL
}

export const SMARTBANNER_SOURCES = {
  [SMARTBANNER_SOURCE_ID_DEFAULT]: {
    title: 'SMARTBANNER.DEFAULT.TITLE_COCHES',
    description: 'SMARTBANNER.DEFAULT.DESCRIPTION_COCHES',
    ctaColor: 'ACCENT',
    ctaText: 'SMARTBANNER.CTA'
  },
  [SMARTBANNER_SOURCE_ID_HOME]: {
    title: 'SMARTBANNER.HOME.TITLE_COCHES',
    description: 'SMARTBANNER.HOME.DESCRIPTION_COCHES',
    ctaColor: 'ACCENT',
    ctaText: 'SMARTBANNER.CTA'
  },
  [SMARTBANNER_SOURCE_ID_ADS_LIST]: {
    title: 'SMARTBANNER.ADS_LIST.TITLE_COCHES',
    description: 'SMARTBANNER.ADS_LIST.DESCRIPTION_COCHES',
    ctaColor: 'ACCENT',
    ctaText: 'SMARTBANNER.CTA_INSTALL'
  },
  [SMARTBANNER_SOURCE_ID_ADS_DETAIL]: {
    title: 'SMARTBANNER.ADS_DETAIL.TITLE_COCHES',
    description: 'SMARTBANNER.ADS_DETAIL.DESCRIPTION_COCHES',
    ctaColor: 'PRIMARY',
    ctaText: 'SMARTBANNER.CTA_INSTALL'
  },
  [SMARTBANNER_SOURCE_ID_EDITORIAL]: {
    title: 'SMARTBANNER.EDITORIAL.TITLE_COCHES',
    description: 'SMARTBANNER.EDITORIAL.DESCRIPTION_COCHES',
    ctaColor: 'ACCENT',
    ctaText: 'SMARTBANNER.CTA'
  }
}
